import { MenuItem as MenuItemBase, Select as SelectBase } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Select = styled(SelectBase)({
  '& .MuiSelect-select': {
    '&:focus': {
      backgroundColor: 'transparent !important',
    },
    '&:selected': {
      backgroundColor: 'transparent !important',
    },
  },
}) as unknown as typeof SelectBase;

export const MenuItem = styled(MenuItemBase)({
  whiteSpace: 'pre-wrap',
  margin: '0 16px',
  padding: '16px 0px',
  '&:not(:last-child)': {
    borderBottom: '1px solid #E0E0E0',
  },
});
